export default "__VITE_ASSET__2546fb75__"